<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Download Cash Statement {{ data.type === 'excel' ? 'Excel' : 'PDF' }}</h2>
  </div>

  <div class="dialog-content">
    <div class="date-type-selector mb-3">
      <mat-button-toggle-group [(ngModel)]="dateType" (change)="onDateTypeChange()">
        <mat-button-toggle value="hijri">Hijri</mat-button-toggle>
        <mat-button-toggle value="gregorian">Gregorian</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="date-fields" *ngIf="dateType === 'gregorian'">
      <div class="date-field">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>From</mat-label>
          <input
            id="fromDate"
            matInput
            [matDatepicker]="fromPicker"
            [(ngModel)]="fromDate"
            [max]="maxDate"
            placeholder="dd/mm/yyyy"
            (dateChange)="onDateChange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="date-field">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>To</mat-label>
          <input
            id="toDate"
            matInput
            [matDatepicker]="toPicker"
            [(ngModel)]="toDate"
            [max]="maxDate"
            placeholder="dd/mm/yyyy"
            (dateChange)="onDateChange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="hijri-date-fields" *ngIf="dateType === 'hijri'">
      <div class="hijri-date-group">
        <label class="hijri-label">From</label>
        <div class="hijri-date-inputs">
          <select class="form-control" [(ngModel)]="fromHijriDay" (ngModelChange)="updateFromHijriDate()">
            <option [ngValue]="null">Day</option>
            <option *ngFor="let day of hijriDays" [ngValue]="day">{{day}}</option>
          </select>
          <select class="form-control" [(ngModel)]="fromHijriMonth" (ngModelChange)="updateFromHijriDate()">
            <option [ngValue]="null">Month</option>
            <option *ngFor="let month of hijriMonths" [ngValue]="month.value">{{month.label}}</option>
          </select>
          <select class="form-control" [(ngModel)]="fromHijriYear" (ngModelChange)="updateFromHijriDate()">
            <option [ngValue]="null">Year</option>
            <option *ngFor="let year of hijriYears" [ngValue]="year">{{year}}</option>
          </select>
        </div>
      </div>

      <div class="hijri-date-group">
        <label class="hijri-label">To</label>
        <div class="hijri-date-inputs">
          <select class="form-control" [(ngModel)]="toHijriDay" (ngModelChange)="updateToHijriDate()">
            <option [ngValue]="null">Day</option>
            <option *ngFor="let day of hijriDays" [ngValue]="day">{{day}}</option>
          </select>
          <select class="form-control" [(ngModel)]="toHijriMonth" (ngModelChange)="updateToHijriDate()">
            <option [ngValue]="null">Month</option>
            <option *ngFor="let month of hijriMonths" [ngValue]="month.value">{{month.label}}</option>
          </select>
          <select class="form-control" [(ngModel)]="toHijriYear" (ngModelChange)="updateToHijriDate()">
            <option [ngValue]="null">Year</option>
            <option *ngFor="let year of hijriYears" [ngValue]="year">{{year}}</option>
          </select>
        </div>
      </div>
    </div>

    <div *ngIf="validationError" class="validation-error">
      <span class="error-message">{{ validationError }}</span>
    </div>
  </div>

  <div class="dialog-actions">
    <button class="btn defult_large_btn" (click)="cancel()">
      Cancel
    </button>
    <button class="btn primary_large_btn" (click)="download('ar')" [disabled]="!isFormValid()">
      Download AR
    </button>
    <button class="btn primary_large_btn" (click)="download('en')" [disabled]="!isFormValid()">
      Download EN
    </button>
  </div>
</div>
